import React from "react";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
export type FormFieldProps = {
  label: string;
  type?: string;
  register: UseFormRegisterReturn;
  error?: FieldError;
  placeholder?: string;
};
const FormField: React.FC<FormFieldProps> = ({
  label,
  type = "text",
  register,
  error,
  placeholder
}) => <div className="space-y-2" data-sentry-component="FormField" data-sentry-source-file="index.tsx">
        <label className="block text-sm font-medium text-slate-200">
            {label}
        </label>
        <Input type={type} {...register} placeholder={placeholder} className={cn("w-full p-1 rounded-lg !bg-slate-950 !border-slate-700 text-slate-200 shadow-sm focus:border-sky-400 focus:ring-sky-400 placeholder-slate-500 transition-colors", error && "border-red-900 focus:border-red-500 focus:ring-red-500")} data-sentry-element="Input" data-sentry-source-file="index.tsx" />
        {error && <p className="text-red-400 text-xs">{error.message}</p>}
    </div>;
export default FormField;